// Static V1 recommended topics per subject.
// 3 topics per subject; each is a natural-language student question that becomes the first chat message.
// V2 can replace this with AI-generated personalized recommendations.

export const RECOMMENDED_TOPICS = {
  Matematik: [
    "Denklem çözmenin adımlarını basit bir örnekle anlatır mısın?",
    "Yüzde hesabı nedir? Günlük hayattan bir örnekle açıklar mısın?",
    "Kesirlerle toplama çıkarma yaparken nelere dikkat etmeliyim?",
  ],
  "Türkçe": [
    "Bir paragrafın ana fikrini nasıl bulurum? Örnekle anlat.",
    "Fiilimsi türleri nelerdir? Kısaca örneklerle açıkla.",
    "Etkili bir kompozisyon yazmanın 5 temel kuralı nedir?",
  ],
  "Fen Bilimleri": [
    "Fotosentez nedir? Adım adım anlatır mısın?",
    "Kuvvet ve hareket ilişkisini basit bir örnekle açıklar mısın?",
    "Maddenin halleri arasındaki farklar nelerdir?",
  ],
  Fizik: [
    "Newton'un hareket yasalarını kısaca ve örneklerle anlatır mısın?",
    "Kinetik enerji ile potansiyel enerji arasındaki fark nedir?",
    "Elektrik akımı ve gerilim arasındaki ilişkiyi açıklar mısın?",
  ],
  Kimya: [
    "Asit ve baz nedir? Günlük hayattan örnekler verir misin?",
    "Periyodik tabloyu nasıl okurum? Kısaca öğret.",
    "Kimyasal tepkime denklemini nasıl denkleştiririm?",
  ],
  Biyoloji: [
    "Hücre nedir? Bitki ve hayvan hücresi arasındaki farklar neler?",
    "DNA ve gen arasındaki fark nedir?",
    "İnsan sindirim sistemi nasıl çalışır? Adım adım anlat.",
  ],
  Tarih: [
    "Osmanlı Devleti'nin kuruluş dönemini kısaca özetler misin?",
    "Cumhuriyetin ilanına giden süreci ana olaylarla anlat.",
    "Sanayi Devrimi'nin dünya tarihine etkileri nelerdir?",
  ],
  "Coğrafya": [
    "Türkiye'nin iklim tipleri nelerdir? Kısaca örneklerle açıkla.",
    "Kıtaların hareketi (levha tektoniği) nedir?",
    "Nüfus yoğunluğu ve nüfus artış hızı arasındaki fark nedir?",
  ],
  "İngilizce": [
    "Present Perfect Tense'i günlük örneklerle anlatır mısın?",
    "If cümleleri (Conditionals) nasıl kurulur? Türleriyle açıkla.",
    "İngilizce kelime ezberlemenin en etkili yöntemleri nelerdir?",
  ],
};

export function topicsFor(course) {
  return RECOMMENDED_TOPICS[course] || [];
}
